export default __webpack_public_path__ + "static/media/36t.20636039.jpg";